import { render } from "./policy-news-skeleton.vue?vue&type=template&id=291a429f&scoped=true"
import script from "./policy-news-skeleton.vue?vue&type=script&lang=js"
export * from "./policy-news-skeleton.vue?vue&type=script&lang=js"

import "./policy-news-skeleton.vue?vue&type=style&index=0&id=291a429f&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291a429f"]])

export default __exports__